var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecrementButtonArr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64105 8.41304L0.593521 3.32609C-0.0212419 2.70652 -0.158431 1.99761 0.181954 1.19935C0.521044 0.399782 1.1274 0 2.00101 0H11.999C12.8726 0 13.479 0.399782 13.818 1.19935C14.1584 1.99761 14.0212 2.70652 13.4065 3.32609L8.35895 8.41304C8.16481 8.6087 7.9545 8.75543 7.72801 8.85326C7.50152 8.95109 7.25885 9 7 9C6.74115 9 6.49848 8.95109 6.27199 8.85326C6.0455 8.75543 5.83519 8.6087 5.64105 8.41304Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrementButtonArr);
export default __webpack_public_path__ + "static/media/DecrementButtonArr.f1e6db49b4310e18480d4a1d885fc4cf.svg";
export { ForwardRef as ReactComponent };